export const TOP_BAR_MOBILE_PADDING = { horizontal: 12, vertical: 8 };
